import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useFilterState = () => {
  return useSelector((state: RootState) => state.filterEngineRules);
};
